import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import Section from "../ui/Section";
import Glow from "../Glow";
import { usePageContent } from "../../lib/usePageContent";

const DEFAULT_POINTS = [
  { text: "Save more when you bundle solar, roof and concrete cleaning" },
  { text: "Transparent, upfront pricing — no hidden fees" },
  { text: "Every package includes our 100% satisfaction guarantee" },
];

/**
 * PackagesPreview
 * ------------------
 * Compact homepage teaser for the full /packages page - the entire
 * pricing catalogue (PackagesSection.jsx) now lives there instead.
 * Deliberately no pricing here at all, per the brief: a heading, a few
 * short benefit points and one CTA, not a duplicate of the real cards.
 */
export default function PackagesPreview() {
  const page = usePageContent("packages");
  const heading = page?.heading || "Explore Our Packages";
  const intro = page?.intro || "Bundle solar, roof and concrete cleaning for better value.";
  const points = page?.body?.previewPoints?.length ? page.body.previewPoints : DEFAULT_POINTS;
  const ctaLabel = page?.ctaLabel || "View Packages";

  return (
    <Section className="relative overflow-hidden bg-[#02060c] py-20 border-t border-white/5">
      <Glow color="#f79029" className="w-[420px] h-[420px] -bottom-32 -right-32" opacity={0.06} />
      <div className="relative max-w-5xl mx-auto px-6">
        <div className="rounded-3xl bg-gradient-to-r from-[#22d3ee]/10 via-white/[0.03] to-transparent border border-white/10 p-8 md:p-12 flex flex-col md:flex-row items-center gap-10">
          <div className="flex-1">
            <span className="text-[#22d3ee] tracking-widest text-sm font-semibold uppercase">Packages</span>
            <h2 className="mt-3 text-2xl md:text-3xl font-bold text-white tracking-tight">{heading}</h2>
            <p className="mt-3 text-white/60">{intro}</p>
            <ul className="mt-5 space-y-2">
              {points.slice(0, 3).map((p, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-white/70">
                  <CheckCircle2 className="w-4 h-4 text-[#22d3ee] mt-0.5 flex-shrink-0" />
                  {p.text}
                </li>
              ))}
            </ul>
          </div>
          <Link
            to="/packages"
            className="inline-flex items-center gap-2 flex-shrink-0 rounded-full px-7 py-3.5 bg-[#22d3ee] text-black font-semibold hover:bg-white transition-colors whitespace-nowrap"
          >
            {ctaLabel}
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </Section>
  );
}
